import { IGenericInputFactory, IRichText } from '@belong/types';
import { MYACCOUNT_INTERNAL_ROUTES } from '@belong/url-utils';

// List of redirect URLs that can have custom headings on the login page
export const LoginHeadingVariant = {
  [MYACCOUNT_INTERNAL_ROUTES.ACTIVATE_MOBILE_SERVICE]: 'activateMobileHeading',
  [MYACCOUNT_INTERNAL_ROUTES.ACTIVATE_DATA_SERVICE]: 'activateDataHeading',
  [MYACCOUNT_INTERNAL_ROUTES.ORDER_SIM]: 'orderSimHeading',
  DEFAULT: 'heading'
} as const;
export type TLoginHeadingVariant = (typeof LoginHeadingVariant)[keyof typeof LoginHeadingVariant];

export interface ILoginFormContent {
  heading: IRichText;
  activateMobileHeading: IRichText;
  activateDataHeading: IRichText;
  orderSimHeading: IRichText;
  emailInput: IGenericInputFactory<'invalid' | 'required'>;
  passwordInput: IGenericInputFactory<'invalid' | 'required'>;
  showPasswordLabel: string;
  hidePasswordLabel: string;
  forgotPasswordLabel: string;
  submitButtonLabel: string;
}
